import DateFnsUtils from '@date-io/date-fns';
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  MenuItem,
  TextField,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { AppContext } from '../../AppContext';
import { holdOrderReview } from '../../services';
import { clDeliveredOrderLineStatusLookupId, qaCompletedOrderLineStatusLookupId } from '../QaOrderReview/constants';
import { OrderReviewContext } from '../QaOrderReview/OrderReviewContext';

const styles = theme => ({
  holdButton: {
    backgroundColor: '#f44336',
    color: '#fff',
    '&:hover': {
      background: '#d2190b',
    },
    holdButtonFocused: {
      backgroundColor: '#d2190b',
    },
  },
});

const propTypes = {
  classes: PropTypes.object.isRequired,
};

export const HoldOrderButton = withRouter(
  withStyles(styles)(({ classes, history, orderLineId, onClose }) => {
    const { state, dispatch } = useContext(OrderReviewContext);
    const { dispatch: appDispatch } = useContext(AppContext);
    const [model, setModel] = useState({
      reason: null,
      holdDate: new Date(),
      doNotAdjustDueDate: false,
    });

    const [dialogOpen, setDialogOpen] = useState(false);

    const showSnackbar = (message, variant) => {
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: { isOpen: true, message: message, variant: variant },
      });
    };

    const toggleSidebar = open => {
      appDispatch({
        type: 'SET_SIDEBAR_IS_OPEN',
        sidebarIsOpen: open,
      });
    };

    const handleDialogOpen = () => {
      setDialogOpen(true);
    };

    const handleDialogClose = () => {
      setDialogOpen(false);

      !!onClose && onClose();
    };

    const handleReasonOnChange = event => {
      setModel({
        ...model,
        reason: event.target.value,
      });
    };

    const handleHoldDateOnChange = event => {
      setModel({
        ...model,
        holdDate: event,
      });
    };

    const handleDueDateOnChange = event => {
      setModel({
        ...model,
        doNotAdjustDueDate: !model.doNotAdjustDueDate,
      });
    };

    const holdOrderReviewAsync = () => {
      setDialogOpen(false);
      holdOrderReview(orderLineId, model)
        .then(data => {
          if (data) {
            toggleSidebar(false);
            history.push('/orders/qa');
            showSnackbar('Order status updated successfully.', 'success');
          } else {
            showSnackbar('An error occurred. Please try again.', 'error');
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          !!onClose && onClose();
        });
    };

    return (
      <React.Fragment>
        <MenuItem
          onClick={handleDialogOpen}
          disabled={
            state.orderLineStatusLookupId !== qaCompletedOrderLineStatusLookupId &&
            state.orderLineStatusLookupId !== clDeliveredOrderLineStatusLookupId
              ? false
              : true
          }
        >
          Hold Order
        </MenuItem>

        <Dialog open={dialogOpen} onClose={handleDialogClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
            Hold Order
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              The order will be marked as 'Hold' until the given date. Please explain why the order has been placed on
              hold:
            </DialogContentText>
            <TextField
              label="Reason"
              autoFocus
              margin="dense"
              type="text"
              multiline
              fullWidth
              required
              onChange={handleReasonOnChange}
            />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                label="Hold Through Date"
                autoOk
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                value={model.holdDate}
                required
                disablePast
                onChange={event => handleHoldDateOnChange(event)}
              />
            </MuiPickersUtilsProvider>
            <FormControl className={classes.doNotAdjustDueDate}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={model.doNotAdjustDueDate}
                      onChange={event => handleDueDateOnChange(event)}
                      value={model.doNotAdjustDueDate}
                    />
                  }
                  label="Do not adjust due date"
                />
              </FormGroup>
            </FormControl>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={handleDialogClose} color="primary">
              Cancel
            </Button>
            <Button onClick={holdOrderReviewAsync}>Submit</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }),
);

HoldOrderButton.propTypes = propTypes;
HoldOrderButton.defaultProps = {};
